import { z } from "zod";

export const dateRangeSchema = z.object({
  from: z.date().optional(),
  to: z.date().optional(),
});

export type DateRangeSchema = z.infer<typeof dateRangeSchema>;
